__turbopack_context__.v({
  "column": "Collapse-module-scss-module__GQPQYq__column",
  "twoColumns": "Collapse-module-scss-module__GQPQYq__twoColumns",
});
